'use client'

import { ReactNode } from 'react'
import Logger from '@/helpers/logger'
import { AppProvider } from '@/providers/app-provider'
import { ChamberOfCommerceProvider } from '@/providers/chamber-of-commerce-provider'
import { LocaleProvider } from '@/providers/locale-provider'
import { RegistrationDataProvider } from '@/providers/registration-data-provider/registration-data-provider'
import { UserInteractivityProvider } from '@/providers/user-interactivity-provider'
import { DictionaryProviderWrapper } from '@/providers/DictionaryProviderWrapper'
import { UserProvider } from '@/providers/user-provider'
import { DictionariesByLocale, LocaleStrings } from '@lib-helpers'
import { ConfigProvider } from '@/providers/config-provider'

interface ProvidersProps {
    children: ReactNode
    dictionariesByLocale: DictionariesByLocale
    locale: LocaleStrings
}

export default function Providers({ children, dictionariesByLocale, locale }: ProvidersProps) {
    if (!dictionariesByLocale || Object.keys(dictionariesByLocale).length === 0) {
        Logger.warn('Translations could not be loaded.')
    }

    return (
        <ConfigProvider>
            <UserProvider>
                <LocaleProvider defaultLocale={locale}>
                    <DictionaryProviderWrapper dictionariesByLocale={dictionariesByLocale}>
                        <UserInteractivityProvider>
                            <RegistrationDataProvider>
                                <ChamberOfCommerceProvider>
                                    <AppProvider>
                                        <>{children}</>
                                    </AppProvider>
                                </ChamberOfCommerceProvider>
                            </RegistrationDataProvider>
                        </UserInteractivityProvider>
                    </DictionaryProviderWrapper>
                </LocaleProvider>
            </UserProvider>
        </ConfigProvider>
    )
}
